"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeCompanyDTO = void 0;
var company_1 = require("./company");
Object.defineProperty(exports, "decodeCompanyDTO", { enumerable: true, get: function () { return company_1.decodeCompanyDTO; } });
//# sourceMappingURL=index.js.map